import styles from './Select.module.css';
import { useTranslation } from 'react-i18next';
import { FormControl, MenuItem, Select as MuiSelect, FormHelperText } from '@mui/material';

function Select({
    options = [],
    value,
    onChange,
    placeholder,
    name,
    id,
    required = false,
    disabled = false,
    error,
    className = '',
    wrapperClassName = '',
    size = 'normal',
}) {
    const wrapperClasses = `${styles.selectWrapper} ${size === 'small' ? styles.small : ''} ${wrapperClassName}`.trim();
    const { t } = useTranslation('validation');

    let errorMessage = null;
    if (error) {
        if (typeof error === 'object' && error.code) {
            if (error.params) {
                const entries = Object.entries(error?.params ?? {});
                const value = entries.length > 0 ? entries[0][1] : undefined;
                errorMessage = t(error.code, { toReplace: value });
            } else {
                errorMessage = t(error.code);
            }
        } else if (typeof error === 'string') {
            errorMessage = error;
        }
    }
    const selectValue = value ?? '';
    const muiSize = size === 'small' ? 'small' : 'medium';

    return (
        <FormControl className={wrapperClasses} error={Boolean(error)} size={muiSize} fullWidth>
            <MuiSelect
                id={id}
                name={name}
                value={selectValue}
                onChange={onChange}
                required={required}
                disabled={disabled}
                displayEmpty
                className={className}
                MenuProps={{
                    PaperProps: {
                        sx: {
                            backgroundColor: 'var(--box-background-color)',
                            color: 'var(--text-color)',
                            border: '1px solid rgba(255, 255, 255, 0.1)',
                        },
                    },
                }}
                sx={{
                    backgroundColor: 'rgba(255, 255, 255, 0.05)',
                    color: 'var(--text-color)',
                    textAlign: 'left',
                    height: muiSize === 'small' ? 36 : 44,
                    '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: 'rgba(255, 255, 255, 0.1)',
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: 'rgba(255, 255, 255, 0.2)',
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: 'var(--button-primary)',
                    },
                    '& .MuiSelect-select': {
                        textAlign: 'left',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'flex-start',
                        padding: muiSize === 'small' ? '8px 12px' : '12px 16px',
                    },
                    '& .MuiSelect-icon': {
                        color: 'var(--text-color)',
                    },
                    '& .MuiInputLabel-root': {
                        color: 'rgba(255, 255, 255, 0.6)',
                    },
                    '& .MuiInputLabel-root.Mui-focused': {
                        color: 'var(--button-primary)',
                    },
                }}
            >
                {options.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                        {option.label}
                    </MenuItem>
                ))}
            </MuiSelect>
            {error && <FormHelperText className={styles.errorText}>{errorMessage}</FormHelperText>}
        </FormControl>
    );
}

export default Select;